import { useSessionState } from '../../shared/hooks/session-state-hook';
import { sessionKey } from '../../shared/util/session-storage';
// NotesModal.js
import React, { useState, useEffect, useContext } from 'react';
import Modal from '../../shared/components/UIElements/Modal';
import Button from '../../shared/components/FormElements/Button';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/Context/auth-context';
import './NotesModal.css';
import { BACKEND_URL } from '../../shared/util/backend-url';

const NotesModal = ({ show, onCancel, patientId }) => {
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote, clearNote] = useSessionState(
    sessionKey(`doctor:${auth.doctorId}`, `notes:${patientId}`),
    ''
  );

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const responseData = await sendRequest(
          `${BACKEND_URL}/api/notes/${patientId}`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth.token
          }
        );
        setNotes(responseData.notes);
      } catch (err) {}
    };
    if (show) fetchNotes();
  }, [sendRequest, patientId, show, auth.token]);

  const addNoteHandler = async () => {
    if (!newNote.trim()) return;
    try {
      const responseData = await sendRequest(
        `${BACKEND_URL}/api/notes/`,
        'POST',
        JSON.stringify({
          content: newNote,
          patient: patientId,
          doctor: auth.doctorId
        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth.token
        }
      );
      setNotes((prev) => [...prev, responseData.note]);
      clearNote();
    } catch (err) {}
  };

  return (
    <Modal
      show={show}
      onCancel={onCancel}
      header="Doctor's Notes"
      footerClass="notes-modal__footer"
      footer={
        <div className="notes-modal__actions">
          <Button onClick={addNoteHandler}>Save Note</Button>
          <Button danger onClick={onCancel}>
            Close
          </Button>
        </div>
      }
    >
      <div className="notes-modal__content">
        <h3>Previous Notes:</h3>
        <div className="notes-scroll-container">
          <ul className="notes-list">
            {notes.map((note) => (
              <li key={note._id} className="note-item">
                <p>{note.content}</p>
                <small>
                  🕒{' '}
                  {new Date(note.createdAt).toLocaleString('en-IN', {
                    dateStyle: 'medium',
                    timeStyle: 'short'
                  })}
                </small>
              </li>
            ))}
          </ul>
        </div>
        <label htmlFor="newNote">Add a note</label>
        <textarea
          id="newNote"
          rows="4"
          value={newNote}
          onChange={(event) => setNewNote(event.target.value)}
        />
        <p className="session-save-note">Unfinished notes are kept in this tab.</p>
      </div>
    </Modal>
  );
};

export default NotesModal;
